import Head from 'next/head';

import IdentificationScreen from '../../components/authentication/IdentificationScreen';
import AccountSetupLayout from '../../components/authentication/AccountSetupLayout';
import BrandLayout from '../../components/brand/BrandLayout';

const Phone = () => {
  return (
    <BrandLayout>
      <AccountSetupLayout type="phone">
        <Head>
          <title>AfricaSasa Merchant | Register Account</title>
        </Head>
        <IdentificationScreen />
      </AccountSetupLayout>
    </BrandLayout>
  );
};

export default Phone;
